import {
  basicSegmentIdentifyUser,
  basicSegmentTrackEvent,
  basicSegmentTrackPage,
  type ExtraEventOptions,
  type SegmentEventOptions,
  type SegmentUserData,
} from '../../analytics/segment/segment_tracking';
import { getUser } from '../auth/selectors';
import { createAppThunk } from '../types';

export const segmentTrackEvent = createAppThunk(
  (options: SegmentEventOptions, extraOpts?: ExtraEventOptions) =>
    (_dispatch, getState) => {
      basicSegmentTrackEvent({
        options,
        extraOpts,
        userData: getUser(getState()),
      });
    },
);

export const segmentTrackPage = createAppThunk(
  (page?: { title?: string; entityId?: string }) => (_dispatch, getState) => {
    basicSegmentTrackPage({
      page: { title: page?.title, entityId: page?.entityId },
      userData: getUser(getState()),
    });
  },
);

export const segmentIdentifyUser = createAppThunk(
  (args: {
    userData: SegmentUserData;
    extraOpts: ExtraEventOptions | undefined;
  }) =>
    (_dispatch, getState) => {
      basicSegmentIdentifyUser({
        userData: getUser(getState()),
        segmentUserData: args.userData,
        extraOpts: args.extraOpts,
      });
    },
);
